import React, { useState } from 'react';

import AddColorPopUp from '@components/colors/AddColorPopUp';

import { printApiError } from '@utils/Util';

import { PANTONE_OR_HEX_CODE, SWATCH } from '@/constants/constant';

const AddColorModal = ({
	item,
	stylesData,
	addDesignIndex,
	setOrderStyles,
	setRemovedColorIds,
	removedColorIds,
	isEdit,
	editColorPopUp,
	setEditColorPopUp,
	colorType,
	selectedColorEditList,
	selectedColorEditName,
	setIsOverflow,
	disabled
}) => {
	const [selectedColorList, setSelectedColorList] = useState([]);

	const onAddNewColors = (item) => {
		const newData = [...stylesData];
		const orderData = newData.find((ite) => ite.id === addDesignIndex);
		if (!orderData) {
			return;
		}
		const newColorWiseData = getSizeWiseQuantity(
			item,
			orderData,
			item.id,
			item.representedBy === PANTONE_OR_HEX_CODE ? PANTONE_OR_HEX_CODE : SWATCH
		);
		orderData.colorWiseSizeQuantityPairList = [
			...orderData.colorWiseSizeQuantityPairList,
			newColorWiseData
		];
		const index = newData.findIndex((ite) => ite.id === addDesignIndex);
		if (index !== -1) {
			newData[index] = orderData;
			setOrderStyles(newData);
			setSelectedColorList([...selectedColorList, item]);
		} else {
			printApiError('Order data index not found');
		}
	};
	const getSizeWiseQuantity = (item, orderData, itemId, type) => {
		let newColorWiseSize = {};
		if (type === SWATCH) {
			newColorWiseSize = {
				...item,
				representedBy: SWATCH,
				id: itemId
			};
		} else {
			newColorWiseSize = {
				...item,
				name: item?.name,
				id: itemId
			};
		}
		let sizes = [];
		if (orderData.colorWiseSizeQuantityPairList?.length > 0) {
			sizes = orderData.colorWiseSizeQuantityPairList[0]?.sizeQuantityPairList.map((item) => {
				return {
					...item,
					quantity: 0
				};
			});
		} else if (orderData.sizeQuantityPairList?.length > 0) {
			sizes = orderData.sizeQuantityPairList?.map((item) => {
				return {
					...item,
					quantity: 0
				};
			});
		}
		newColorWiseSize.sizeQuantityPairList = sizes;
		return newColorWiseSize;
	};
	return (
		<AddColorPopUp
			selectedColors={item.colorWiseSizeQuantityPairList}
			onAddNewColors={onAddNewColors}
			productId={item.productId}
			showRemovedColors={true}
			removedColorIds={removedColorIds}
			setRemovedColorIds={setRemovedColorIds}
			isEdit={isEdit}
			editColorPopUp={editColorPopUp}
			setEditColorPopUp={setEditColorPopUp}
			colorType={colorType}
			selectedColorEditList={selectedColorEditList}
			selectedColorEditName={selectedColorEditName}
			setIsOverflow={setIsOverflow}
			disabled={disabled}
		/>
	);
};

export default AddColorModal;
